module.exports = __webpack_public_path__ + "img/5-WHEEL.0d7ddbdf.png";